var scope_0 = require('/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16631439e610001581670354251e4b9c.js').default;
var scope_1 = require('/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4bf3d53a2da7b88a4192b4b5aa04ce0.js').default;
var scope_2 = require('/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f1e982badbeed22734e8b01b3611d65f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    